import type { LocationSupplier } from './Types';
import type {
  OnboardingInventoryRow,
  OnboardingStep
} from './Types/Onboarding.types';

export const PURCHASE_UNITS = [
  'Case',
  'Pack',
  'Each',
  'Pound',
  'Jug',
  'Gallon',
  'Bag'
] as const;

/** Units available in the package-size unit dropdown */
export const PACKAGE_UNITS = [
  'Pack',
  'Packs',
  'Each',
  'Pound',
  'Ounce',
  'Kilogram',
  'Gram',
  'Liter',
  'Milliliter',
  'Bottle',
  'Box',
  'Dozen',
  'Pieces',
  'Bag',
  'Case',
  'Jug',
  'Gallon'
] as const;

export const DEMO_ONBOARDING_STEPS: OnboardingStep[] = [
  { id: 'restaurant', label: 'Restaurant', status: 'done' },
  { id: 'items', label: 'Items', status: 'active' },
  { id: 'storage', label: 'Storage', status: 'upcoming' },
  { id: 'suppliers', label: 'Suppliers', status: 'upcoming' },
  { id: 'review', label: 'Review', status: 'upcoming' },
  { id: 'par', label: 'Par levels', status: 'upcoming' },
  { id: 'finish', label: 'Finish', status: 'upcoming' }
];

export const DEMO_SUPPLIERS: LocationSupplier[] = [
  {
    supplier_id: 'demo-sup-restaurant-depot',
    business_name: 'Restaurant Depot',
    network_type: 'out_of_network',
    email: null,
    phone: null,
    contact_person_name: null,
    is_archived: false,
    active: true
  },
  {
    supplier_id: 'demo-sup-jetro',
    business_name: 'Jetro',
    network_type: 'out_of_network',
    email: null,
    phone: null,
    contact_person_name: null,
    is_archived: false,
    active: true
  },
  {
    supplier_id: 'demo-sup-lala',
    business_name: 'Lala Produce',
    network_type: 'out_of_network',
    email: null,
    phone: null,
    contact_person_name: null,
    is_archived: false,
    active: true
  },
  {
    supplier_id: 'demo-sup-avanti',
    business_name: 'Avanti',
    network_type: 'out_of_network',
    email: null,
    phone: null,
    contact_person_name: null,
    is_archived: false,
    active: true
  }
];

export const DEMO_ONBOARDING_ITEMS: OnboardingInventoryRow[] = [
  {
    localId: 'demo-1',
    name: 'Brioche Burger Buns',
    category: '',
    purchasedAs: 'Case',
    packageQuantity: '72',
    packageUnit: 'Each',
    parLevel: '4 cases',
    lastPrice: '$38.50',
    supplierId: 'demo-sup-restaurant-depot',
    confidence: 'High',
    needsReview: false
  },
  {
    localId: 'demo-2',
    name: 'Ground Beef 80/20',
    category: '',
    purchasedAs: 'Case',
    packageQuantity: '40',
    packageUnit: 'Pound',
    parLevel: '3 cases',
    lastPrice: '$142.00',
    supplierId: 'demo-sup-jetro',
    confidence: 'High',
    needsReview: false
  },
  {
    localId: 'demo-3',
    name: 'Canola Frying Oil',
    category: '',
    purchasedAs: 'Jug',
    packageQuantity: '35',
    packageUnit: 'Pound',
    parLevel: '',
    lastPrice: '$29.75',
    supplierId: 'demo-sup-restaurant-depot',
    confidence: 'Medium',
    needsReview: true
  },
  {
    localId: 'demo-4',
    name: 'Yellow Onions',
    category: '',
    purchasedAs: 'Bag',
    packageQuantity: '50',
    packageUnit: 'Pound',
    parLevel: '2 bags',
    lastPrice: '$24.90',
    supplierId: 'demo-sup-lala',
    confidence: 'High',
    needsReview: false
  },
  {
    localId: 'demo-5',
    name: 'Burger Box 6 in',
    category: '',
    purchasedAs: 'Case',
    packageQuantity: '',
    packageUnit: '',
    parLevel: '',
    lastPrice: '$41.00',
    supplierId: 'demo-sup-avanti',
    confidence: 'Low',
    needsReview: true
  }
];
